// components/ConfirmPopup.js
import React from "react";
import "./ConfirmPopup.css";

const ConfirmPopup = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <p>{message}</p>
        <div className="modal-actions">
          <button className="btn danger" onClick={onConfirm}>
            Yes, Delete
          </button>
          <button className="btn" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
